import { EWarrantDocument } from 'data/eWarrant/eWarrant.types';
import { downloadEWarrantDocument } from 'data/eWarrant/eWarrant.api';

/**
 * Downloads one e-warrant document and saves it client side under its documentName —
 * the same blob -> object URL -> temporary anchor click pattern exportLogsToFile uses.
 */
const downloadDocument = async (senderId: string, eWarrantDocument: EWarrantDocument): Promise<void> => {
  const response = await downloadEWarrantDocument(senderId, eWarrantDocument.docId);

  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: eWarrantDocument.contentType || undefined }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', eWarrantDocument.documentName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export default downloadDocument;
